<template>
    <div class="row g-3">
        <div class="col-lg-6">
            <button @click="emit('cancel')" type="button" class="btn btn-secondary w-100">{{ cancelText }}</button>
        </div>
        <div class="col-lg-6">
            <button @click="emit('submit')" type="submit" class="btn btn-danger w-100">{{ saveText }}</button>
        </div>
    </div>
</template>

<script setup>
/* eslint-disable-next-line */
const props = defineProps({
    cancelText: {type: String, default: "Cancel"},
    saveText: {type: String, default: "Save"}
});
/* eslint-disable-next-line */
const emit = defineEmits(['cancel', 'submit']);

</script>